import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import InternalOfficialVerificationsTable from './components/InternalVerificationsTable';
import AgencyVerificationsTable from './components/AgencyVerificationsTable';
import { useUser } from '@hooks/useUser';
import { useAgency } from '@hooks/useAgency';
import { checkUserAuthorized, searchAllOfficialsRoles } from '../../utils/authorization';

export const OfficialVerificationsPage: React.FC = () => {
  const { user } = useUser();
  const { agency } = useAgency();
  

  const isInternalVerification = useMemo(() => {
    return (
      user &&
      checkUserAuthorized(user.profile, searchAllOfficialsRoles) &&
      agency?.id === user.profile.agency_id // surepass admin is not managing another agency
    );
  }, [user, agency?.id])

  return (
    <Box>
      <Typography variant="xxl">Verifications</Typography>
      {
        isInternalVerification
          ? <InternalOfficialVerificationsTable />
          : <AgencyVerificationsTable /> 
      }
    </Box>
  );
};

export default OfficialVerificationsPage;
